// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Llama.EmployeeProjectFavorite')
class Llama__EmployeeProjectFavorite {
    @jsonProperty(() => Llama__EmployeeProjectFavorite.Id)
    id: Llama__EmployeeProjectFavorite.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "string" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employeeEmail", "project", "projectId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employeeEmail", "project", "projectId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employeeEmail", "project", "projectId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "employeeEmail": "string", "project": "Llama.Project", "projectId": "Llama.Project.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "string" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ project: () => Llama.Project } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = String;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θemployeeEmail? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θproject? = Signals.proxySignalDeferred<Llama.Project>(() => undefined);
    private readonly θprojectId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θcreatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θupdatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θdeletedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θversionNumber? = Signals.proxySignalDeferred<number>(() => undefined);

    static get __type(): 'Llama.EmployeeProjectFavorite' {
        return 'Llama.EmployeeProjectFavorite'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Llama.EmployeeProjectFavorite' {
        return 'Llama.EmployeeProjectFavorite'
    }

    static get __baseType(): 'Llama.EmployeeProjectFavorite' {
        return 'Llama.EmployeeProjectFavorite'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Llama.EmployeeProjectFavorite' {
        return 'Llama.EmployeeProjectFavorite'
    }

    get [BoInfoSymbol]() {
        return Llama__EmployeeProjectFavorite[BoInfoSymbol]
    }

    get employeeEmail(): string {
        return this.θemployeeEmail?.()
    }

    set employeeEmail(employeeEmail) {
        this.θemployeeEmail.set(LowgileDataUtil.coerceDataType(employeeEmail, 'string', false, true))
    }

    get project(): Llama.Project {
        return this.θproject?.()
    }

    set project(project) {
        this.θproject.set(LowgileDataUtil.coerceDataType(project, Llama.Project, false, true))
        if (project) {
            this.θprojectId.set(project.id)
        } else if (project === null && project) {
            this.θprojectId.set(null)
        }
    }

    get projectId(): Llama.Project.Id {
        return this.θprojectId?.()
    }

    set projectId(projectId) {
        if (projectId === null) this.θproject.set(null)
        if (this.project?.id && projectId != this.project.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θprojectId.set(LowgileDataUtil.coerceDataType(projectId, 'string', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Llama__EmployeeProjectFavorite>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        LowgileDataUtil.assignCommonProperties(this, init)
        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Llama__EmployeeProjectFavorite()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Llama__EmployeeProjectFavorite>, restrictToClass?: Class<Partial<Llama__EmployeeProjectFavorite>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            employeeEmail: z.string(),
            get project() { return Llama.Project.$getSchema() },
            projectId: Llama.Project.$getSchema().shape.id,
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Llama__EmployeeProjectFavorite.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('employeeEmail', 'project', 'projectId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Llama__EmployeeProjectFavorite {
        return equal(this, other)
    }
}

namespace Llama__EmployeeProjectFavorite { }

export import EmployeeProjectFavorite = Llama__EmployeeProjectFavorite
setTimeout(() => {
    jsonProperty(() => String)(Llama__EmployeeProjectFavorite.prototype, 'employeeEmail')
    jsonProperty(() => Llama.Project)(Llama__EmployeeProjectFavorite.prototype, 'project')
    jsonProperty(() => String)(Llama__EmployeeProjectFavorite.prototype, 'projectId')
    jsonProperty(() => Date)(Llama__EmployeeProjectFavorite.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Llama__EmployeeProjectFavorite.prototype, 'createdBy')
    jsonProperty(() => Date)(Llama__EmployeeProjectFavorite.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__EmployeeProjectFavorite.prototype, 'updatedBy')
    jsonProperty(() => Date)(Llama__EmployeeProjectFavorite.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__EmployeeProjectFavorite.prototype, 'deletedBy')
    jsonProperty(() => Number)(Llama__EmployeeProjectFavorite.prototype, 'versionNumber')
})

export const EmployeeProjectFavoriteθId = String;

export type EmployeeProjectFavoriteθId = string;

namespace Llama__EmployeeProjectFavorite {
    export type Id = NominalType<string, 'Llama.EmployeeProjectFavorite'>

}
